import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, imgUrl } from "../lib/api";
import { Calculator } from "lucide-react";

export default function CostingGallery() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/costs").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-10 max-w-6xl mx-auto">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-zinc-400">Production</p>
          <h1 className="font-heading text-4xl font-bold mt-1 tracking-tight" data-testid="costing-title">Costing</h1>
          <p className="text-zinc-500 mt-2 text-sm max-w-xl">Per-unit cost sheets built from your techpacks. Add material rates, labor, overheads and shipping — see landed cost, wholesale and retail live.</p>
        </div>
      </div>

      {loading ? (
        <div className="mt-10 text-sm text-zinc-400">Loading…</div>
      ) : items.length === 0 ? (
        <div className="mt-10 border-2 border-dashed border-zinc-200 rounded-lg p-16 text-center text-zinc-400" data-testid="costing-empty-state">
          <Calculator size={32} className="mx-auto mb-4 text-zinc-300" />
          <p className="text-sm">No cost sheets yet.</p>
          <p className="text-xs mt-2">Open a techpack and click <span className="font-medium text-zinc-600">Create cost sheet</span>.</p>
          <Link to="/techpacks" className="mt-4 inline-block bg-zinc-950 text-white px-6 py-2.5 rounded-md text-sm font-medium hover:bg-zinc-800 transition-colors">Browse techpacks</Link>
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((cs) => (
            <Link key={cs.id} to={`/costing/${cs.id}`} data-testid={`costsheet-card-${cs.id}`}
              className="group border border-zinc-200 bg-white rounded-lg overflow-hidden hover:border-zinc-400 transition-colors">
              {cs.cover_image ? (
                <img src={imgUrl(cs.cover_image)} alt={cs.style_name} className="w-full h-48 object-cover group-hover:scale-[1.02] transition-transform" />
              ) : (
                <div className="w-full h-48 bg-zinc-100 flex items-center justify-center text-zinc-300"><Calculator size={32} /></div>
              )}
              <div className="p-4">
                <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-400">{cs.style_number}</p>
                <p className="text-sm font-medium mt-0.5 truncate">{cs.style_name}</p>
                <div className="grid grid-cols-3 gap-2 mt-3">
                  <div>
                    <p className="text-[10px] uppercase text-zinc-400">Landed</p>
                    <p className="text-sm font-medium">{cs.currency} {cs.landed_cost.toFixed(2)}</p>
                  </div>
                  <div>
                    <p className="text-[10px] uppercase text-zinc-400">WHSL</p>
                    <p className="text-sm font-medium">{cs.currency} {cs.wholesale_price.toFixed(2)}</p>
                  </div>
                  <div>
                    <p className="text-[10px] uppercase text-zinc-400">Retail</p>
                    <p className="text-sm font-medium">{cs.currency} {cs.retail_price.toFixed(2)}</p>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
